var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 382,
    viewBox: "0 0 382 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.87 190.871C241.493 190.871 290.041 170.761 325.836 134.966C361.631 99.1708 381.741 50.6223 381.741 0.000244141C331.119 0.000241928 282.57 20.1093 246.775 55.9045C210.98 91.6997 190.87 140.249 190.87 190.871Z",
    fill: "#00AD57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.05823 381.742C50.5638 381.742 99.1124 361.632 134.908 325.837C170.703 290.041 190.812 241.493 190.812 190.871C140.19 190.871 91.6416 210.98 55.8464 246.775C20.0512 282.57 -0.0582278 331.12 -0.05823 381.742Z",
    fill: "#00AD57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.871 190.871C190.871 165.801 185.932 140.975 176.336 117.814C166.74 94.6529 152.676 73.6086 134.946 55.8839C117.215 38.1592 96.1674 24.1015 73.0032 14.5128C49.839 4.92406 25.0125 -0.00739242 -0.0578371 0.000244654C-0.0578393 25.0706 4.88128 49.895 14.4771 73.0563C24.0728 96.2176 38.1372 117.262 55.8673 134.987C73.5975 152.711 94.6458 166.77 117.81 176.358C140.974 185.947 165.801 190.879 190.871 190.871Z",
    fill: "#00AD57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.741 381.742C381.741 331.12 361.631 282.57 325.836 246.775C290.041 210.98 241.493 190.871 190.87 190.871C190.87 241.493 210.98 290.041 246.775 325.837C282.57 361.632 331.119 381.742 381.741 381.742Z",
    fill: "#00AD57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 381.741,
    height: 381.741,
    fill: "white",
    transform: "translate(381.741) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetals);
export default __webpack_public_path__ + "static/media/petals.7959706f6e19192642141d7c14b1299b.svg";
export { ForwardRef as ReactComponent };